import React from 'react'
import IconBase from './IconBase'

const Add = props => (
  <IconBase viewBox="0 0 41.7 41.49" {...props}>
    <clipPath id="x">
      <path d="m-163.5-49.04h41.7v41.48h-41.7z" />
    </clipPath>
    <clipPath id="w">
      <path d="m-163.5-49.04h41.7v41.48h-41.7z" />
    </clipPath>
    <clipPath id="v">
      <path d="m-163.5-49.04h41.7v41.48h-41.7z" />
    </clipPath>
    <clipPath id="u">
      <path d="m-163.5-49.04h41.7v41.48h-41.7z" />
    </clipPath>
    <clipPath id="t">
      <path d="m-163.5-49.04h41.7v41.48h-41.7z" />
    </clipPath>
    <clipPath id="s">
      <path d="m-163.5-49.04h41.7v41.48h-41.7z" />
    </clipPath>
    <clipPath id="r">
      <path d="m-163.5-49.04h41.7v41.48h-41.7z" />
    </clipPath>
    <clipPath id="q">
      <path d="m-163.5-49.04h41.7v41.48h-41.7z" />
    </clipPath>
    <clipPath id="p">
      <path d="m-163.5-49.04h41.7v41.48h-41.7z" />
    </clipPath>
    <clipPath id="o">
      <path d="m-163.5-49.04h41.7v41.48h-41.7z" />
    </clipPath>
    <clipPath id="n">
      <path d="m-163.5-49.04h41.7v41.48h-41.7z" />
    </clipPath>
    <clipPath id="m">
      <path d="m-163.5-49.04h41.7v41.48h-41.7z" />
    </clipPath>
    <g transform="translate(163.5 49.044)">
      <g clipPath="url(#x)">
        <path
          d="m-132.2-10.34c-.01 0-.01 0 0 0m.01-.02c-.01 0-.01 0-.01.01 0 0 .01 0 .01-.01m.02-.01c-.01 0-.01.01 0 0zm.03-.01c-.01.01-.02.01-.03.01 0 0 .01 0 .03-.01m-28.27-7.06c3.81 6.15 10.53 9.89 17.76 9.89h.05c3.64-.01 7.22-.97 10.38-2.79h.01s-.01 0-.01.01l-2.86-4.93 2.86 4.92c-3.16 1.82-6.75 2.78-10.4 2.78-3.67 0-7.27-.96-10.45-2.77-3-1.72-5.53-4.17-7.34-7.11m0-.01s0 .01 0 0zm-.01-.02c0 .01 0 .01 0 0m-.01 0s.01 0 0 0zm0-.01s0 .01 0 0zm-.15-.25s.01 0 0 0 0 0 0 0m-.01-.01c.01 0 .01 0 0 0s.01 0 0 0m-.12-.2s.01.01 0 0c.01 0 .01 0 0 0m0-.02s0 .01 0 0zm-.01-.01c0 .01 0 .01 0 0zm-.01-.02s.01.01 0 0c0 .01 0 .01 0 0m0-.01c0 .01 0 .01 0 0m-.02-.03c0 .01 0 .01 0 0m-.02-.03s0 .01 0 0zm-.02-.03c0 .01.01.01 0 0zm0-.01c0 .01 0 .01 0 0zm-.02-.02c0 .01 0 .01.01.01 0 0-.01-.01-.01-.01m-.01-.01s.01.01 0 0c.01 0 .01 0 0 0m0-.02c0 .01 0 .01.01.01-.01 0-.01-.01-.01-.01m-.01-.01s0 .01 0 0zm-.01-.02c0 .01.01.01.01.02s-.01-.01-.01-.02m0-.01s0 .01 0 0zm-.02-.02c0 .01.01.01.01.02 0-.01 0-.01-.01-.02m0-.01c0 .01.01.01 0 0 .01.01 0 .01 0 0m36.43-20.16c1.73 3.08 2.64 6.55 2.63 10.08-.01 7.39-3.95 14.22-10.35 17.91 6.4-3.7 10.34-10.53 10.35-17.93v-.01c0-3.52-.91-6.99-2.63-10.05m-.01-.03c.01.01.01.02.01.03.01 0-.01-.02-.01-.03m-.01-.01s0 .01 0 0zm-.01-.02c0 .01.01.01.01.02 0 0 0-.01-.01-.02m-.01-.01s.01.01 0 0c0 .01 0 .01 0 0m-.01-.02c0 .01.01.01.01.02 0-.01 0-.02-.01-.02m0-.01s0 .01 0 0c0 .01 0 .01 0 0m-.01-.01c0 .01.01.01 0 0 .01.01 0 .01 0 0m-.01 0s.01 0 0 0zm-.02-.06c0 .01.01.01 0 0 0 .01 0 .01 0 0m-.02-.03s0 .01 0 0zm-.02-.03s.01.01 0 0zm-.01-.03s0 .01 0 0zm-.01-.01c0 .01 0 .01 0 0zm-.01-.02c0 .01.01.01 0 0 0 .01 0 .01 0 0m-.02-.04c-.01-.01 0 0 0 0m-.05-.09c0 .01 0 .01 0 0-.01-.01 0 .01 0 0m-.08-.13c.01 0 .01.01 0 0s.01 0 0 0m-.07-.12s.01 0 0 0c-.01-.01 0 0 0 0m-.01-.01c.01 0 .01.01 0 0 0-.01.01 0 0 0m-.04-.04s.01 0 0 0c.01 0 .01 0 0 0m0-.02c0 .01 0 .01 0 0zm0-.01c0 .01 0 .01 0 0m-.02-.01s.01.01 0 0c.01 0 .01 0 0 0m-29.55-6.28c-8.88 6.02-11.67 17.84-6.44 27.2-1.73-3.08-2.63-6.55-2.63-10.08.01-6.85 3.4-13.26 9.07-17.12m.03-.01c-.01.01-.01.01-.01.01s0-.01.01-.01m.03-.02c-.01.01-.01.01-.01.02 0 0 0-.01.01-.02m.01 0c-.01 0-.01 0 0 0m.02-.02c-.01.01-.01.01-.01.01-.01.02 0-.01.01-.01m.01 0c-.01 0 0 0 0 0m.02-.02c-.01.01-.01.01-.01.01s0 0 .01-.01m0-.01s0 .01 0 0c0 .01 0 .01 0 0m.03 0c-.01.01-.01.01-.01.01-.01-.01 0-.01.01-.01m.01-.02c0 .01 0 .01 0 0m.03-.01c-.01 0-.01 0 0 0zm.03-.02c-.01 0-.01 0 0 0m0-.01c0 .01 0 .01 0 0s0 .01 0 0m.03-.01c-.01 0-.01 0 0 0m.02-.02c-.01.01 0 .01 0 0m.02-.02c0 .01-.01.01 0 0 0 0 0 .01 0 0m.03-.02s0 .01 0 0zm.04-.01c-.01 0-.01 0 0 0m.03-.03c-.01 0-.01.01 0 0s-.01 0 0 0m0 0c.01-.01 0 0 0 0m.66-.41c-.01 0-.01 0 0 0zm.05-.04s0 .01 0 0zm.12-.06s-.01.01 0 0c-.01.01 0 0 0 0m.03-.02c-.01 0-.01 0 0 0-.01.01 0 0 0 0m.03-.01c-.01 0-.01 0 0 0zm.03-.02c-.01 0-.01.01 0 0-.01.01-.01 0 0 0m.02-.01c-.01 0-.01 0 0 0m.03-.02c-.01 0-.01.01 0 0-.01 0-.01 0 0 0m10.42-2.78h-.03c-3.65 0-7.23.96-10.39 2.78l2.88 4.96c4.67-2.7 10.42-2.7 15.09 0l2.87-4.96c3 1.72 5.53 4.17 7.35 7.12-3.8-6.16-10.53-9.91-17.77-9.9"
          fill="#fff"
        />
      </g>
      <g clipPath="url(#w)">
        <path
          d="m-153.07-46.26c-.01.01-.01.01-.01.01s-.01 0-.01.01-.01 0-.01.01h-.01s-.01 0-.01.01h-.01s-.01 0-.01.01-.01 0-.01.01h-.01s-.01 0-.01.01h-.01s-.01 0-.01.01h-.02s-.01 0-.01.01h-.01s-.01 0-.01.01h-.04s-.01 0-.01.01h-.04s-.01 0-.01.01h-.04s-.01 0-.01.01h-.03s-.01 0-.01.01h-.03l-.01.01h-.02s-.01.01-.02.01h-.01c-.01 0-.01.01-.01.01h-.01c-.01 0-.01.01-.01.01h-.01c-.01 0-.01.01-.01.01h-.01c-.01 0-.01.01-.01.01h-.01c-.01 0-.01.01-.01.01h-.01l-.01.01h-.01l-.01.01h-.02s-.01 0-.01.01h-.04s-.01 0-.01.01h-.01c-.01 0-.01.01-.01.01h-.01c-.01.01-.01.01-.02.01h-.01c-.01 0-.01.01-.01.01h-.01c-.01.01-.01.01-.01.01h-.01s-.01 0-.01.01h-.01s-.01.01-.02.01h-.01v.02h-.02s-.01 0-.01.01h-.01s-.01 0-.01.01h-.03s-.01 0-.01.01h-.11s-.01 0-.01.01h-.01s-.01 0-.01.01h-.01s-.01 0-.01.01h-.01s-.01 0-.01.01-.01 0-.01.01h-.01s-.01 0-.01.01-.01 0-.01.01-.01 0-.01.01-.01 0-.01.01-.01 0-.01.01-.01 0-.01.01l-.01.01s-.01 0-.01.01-.01 0-.01.01-.01 0-.01.01-.01 0-.01.01-.01 0-.01.01l-.01.01s-.01 0-.01.01-.01 0-.01.01l-.01.01-.01.01c-.01.01-.01.01-.01.01s-.01 0-.01.01c-.01.01-.01.01-.01.01l-.01.01c-.01.01-.01.01-.01.01l-.01.01c-.01.01-.01.01-.01.01s-.01 0-.01.01c-.01.01-.01.01-.01.01l-.01.01c-5.65 4.01-9.04 10.49-9.09 17.41h5.8c.01-5.36 2.87-10.31 7.51-13z"
          fill="#fff"
        />
      </g>
      <g clipPath="url(#v)">
        <path
          d="m-163.49-28.3c0 3.53.9 7 2.63 10.08s0 .01.01.01c0 .01.01.02.01.02s0 .01.01.01c0 .01.01.02.01.02s0 .01.01.01c0 .01 0 .01.01.02s0 .01.01.01c0 .01 0 .01.01.02s0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01v.01.01s0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01v-.06s0 .01.01.01l.01.01s0 .01.01.01 0 .01.01.01v.01s0 .01.01.01 0 .01.01.01v.49.01s0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01 0 .01.01.01c1.81 2.95 4.34 5.39 7.34 7.11l2.86-4.92c-4.53-2.82-7.29-7.77-7.31-13.1v-.01h-5.9"
          fill="#fff"
        />
      </g>
      <g clipPath="url(#u)">
        <path
          d="m-150.21-15.26-2.86 4.92c3.18 1.82 6.78 2.78 10.45 2.78 3.65 0 7.24-.96 10.4-2.78l-2.85-4.92c-4.69 2.7-10.46 2.7-15.14 0"
          fill="#fff"
        />
      </g>
      <g clipPath="url(#t)">
        <path
          d="m-121.8-28.3h-5.8v.02c0 5.36-2.85 10.32-7.49 13.01l2.86 4.92s.01 0 .01-.01.01 0 .01-.01c.01 0 .01 0 .02-.01s.01 0 .01-.01c.01-.01.02-.01.03-.02 6.39-3.67 10.34-10.49 10.35-17.89"
          fill="#fff"
        />
      </g>
      <g clipPath="url(#s)">
        <path
          d="m-132.23-46.26-2.88 4.96c4.64 2.69 7.5 7.64 7.51 13h5.8c0-3.53-.9-7-2.63-10.08-.01-.01-.01-.02-.02-.03s0-.01-.01-.01c0-.01-.01-.01-.01-.02s0-.01-.01-.01c0-.01-.01-.01-.01-.02s0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01v-.01s0-.01-.01-.01 0-.01-.01-.01v-.01s0-.01-.01-.01l-.01-.01s0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01v-.01-.43-.01s0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01 0-.01-.01-.01c-1.78-2.78-4.35-5.21-7.37-6.95"
          fill="#fff"
        />
      </g>
      <g clipPath="url(#r)">
        <path
          d="m-142.65-43.33c-2.65-.01-5.25.69-7.54 2.03l1.68 2.89c3.63-2.09 8.1-2.09 11.73 0l1.68-2.89c-2.29-1.34-4.9-2.04-7.55-2.03"
          fill="none"
        />
      </g>
      <g clipPath="url(#q)">
        <path
          d="m-150.2-41.3c-4.64 2.69-7.5 7.64-7.51 13h3.32v-0.56c0.18-3.98 2.39-7.6 5.85-9.58z"
          fill="none"
        />
      </g>
      <g clipPath="url(#p)">
        <path
          d="m-157.7-28.3v0.02c0 5.36 2.85 10.32 7.49 13.01l1.7-2.93c-3.44-1.97-5.64-5.55-5.85-9.51v-0.34 0.05-0.33z"
          fill="none"
        />
      </g>
      <g clipPath="url(#o)">
        <path
          d="m-136.78-18.2c-1.72.99-3.66 1.53-5.65 1.56h-.35c-1.99-.03-3.95-.57-5.68-1.56l-1.7 2.93c4.68 2.71 10.45 2.71 15.13 0z"
          fill="none"
        />
      </g>
      <g clipPath="url(#n)">
        <path
          d="m-127.6-28.3h-3.32v0.39-0.09 0.18c-0.19 3.98-2.39 7.58-5.85 9.57l1.7 2.93c4.64-2.69 7.49-7.63 7.47-12.98z"
          fill="none"
        />
      </g>
      <g clipPath="url(#m)">
        <path
          d="m-135.1-41.3-1.68 2.9c3.47 1.99 5.68 5.61 5.86 9.6v0.55h3.33c-0.02-5.35-2.87-10.28-7.5-12.96"
          fill="none"
        />
      </g>
    </g>
    <path
      transform="translate(173.49 58.918)"
      d="m-142.95-39.71h-8.17v-8.16c-.21-.84-1.06-1.34-1.9-1.13-.55.14-.99.57-1.13 1.13v8.17h-8.18c-.84.21-1.34 1.06-1.13 1.9.14.55.57.99 1.13 1.13h8.17v8.17c.21.84 1.06 1.34 1.9 1.13.55-.14.99-.57 1.13-1.13v-8.17h8.18c.71-.14 1.21-.79 1.18-1.51.03-.73-.47-1.38-1.18-1.53z"
      fill="#fff"
    />
  </IconBase>
)

export default Add
